import { Container } from '../../components/Container/Container'
import { ADDITIONAL_VALUES_BREADCRUMBS } from './constants'
import { AdditionalValuesContainer } from '../../features/AdditionalValues/AdditionalValuesContainer'
import AdditionalValuesPopupProvider from '../../features/AdditionalValues/Providers/AdditionalValuesPopupProvider'
import AdditionalValuesContextProvider from '../../features/AdditionalValues/Providers/AdditionalValuesContextProvider'

export const AdditionalValuesPage = () => {
  return (
    <AdditionalValuesContextProvider>
      <AdditionalValuesPopupProvider>
        <Container
          title="Additional values"
          breadcrumbs={ADDITIONAL_VALUES_BREADCRUMBS}
        >
          <AdditionalValuesContainer />
        </Container>
      </AdditionalValuesPopupProvider>
    </AdditionalValuesContextProvider>
  )
}
